<template>
    <div class="metaSearch-content" v-if="authorized">
        <section class="header">
            <!-- title -->
            <h4 v-text="localize('metaSearch')"></h4>
        </section>

        <section class="content">
            <div class="content-row">
                <!-- Loading spinner -->
                <div class="content-row-loader" v-if="isLoading">
                    <b-spinner style="width: 3rem; height: 3rem"
                               label="Large Spinner"></b-spinner>
                </div>
                <!-- Providers list -->
                <div class="metaSearch-list">
                    <b-list-group>
                        <b-list-group-item v-for="provider in ProvidersDataSource"
                                           :key="provider.searchAttributes.searchId"
                                           class="metaSearch-list-item"
                                           :class="{ activeProvider: provider.isActive }"
                                           @click="setCurrentProvider(provider)">
                            {{provider.provider}}<span> ({{ provider.totalCount }})</span>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <!-- <div class="arrow" style="width: 5px; margin-left: -12px"></div> -->
                <div class="metaSearch-results m-4">
                    <!-- Searchbox -->
                    <div class="meta-search">
                        <b-navbar-nav>
                            <div class="meta-search-bar">
                                <b-form-input class="meta-form-input form-input"
                                              v-model="searchKey"
                                              v-on:keypress.enter="search"
                                              :placeholder="localize('metaSearch')"></b-form-input>
                                <!-- Search button -->
                                <b-button @click="search()" v-text="localize('search')"></b-button>
                            </div>
                        </b-navbar-nav>
                    </div>
                    <div class="products"
                         v-if="activeProviderData.length > 0 && !isLoading">
                        <b-card no-body
                                v-for="provider in activeProviderData"
                                :key="provider.ssoReference">
                            <b-row class="product-card">
                                <img class="product-cover"
                                     alt="Image"
                                     :src="
                    provider.coverUrl
                      ? provider.coverUrl
                      : '../../assets/images/Empty_Cover.png'
                  " />
                                <b-card-body>
                                    <h5 v-if="provider.title == provider.title">
                                        <a :href="provider.ssoReference" target="_blank">{{ provider.title }}</a>
                                    </h5>

                                    <h5 v-if="provider.title != provider.title">
                                        <a :href="provider.ssoReference" target="_blank">{{ localize('noFoundTitle') }}</a>
                                    </h5>



                                    <h6 v-if="provider.authors == provider.authors[0]">
                                        {{ provider.authors[0] }}
                                    </h6>
                                    <h6 v-if="provider.authors != provider.authors[0]">
                                        {{ localize('noAuthor') }}
                                    </h6>
                                    <h6>{{ provider.publicationDate | formatDate }}</h6>
                                </b-card-body>
                            </b-row>
                        </b-card>
                        <!-- Pagination -->
                        <b-pagination v-model="currentPage"
                                      :total-rows="rows"
                                      align="fill"
                                      @change="handlePageChange"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<!-- Vue model -->
<script>
    import Vue from "vue";
    import axios from "axios";
    import moment from 'moment';
    import config from "../../config/config.js";
    import { checkAuth } from "@common/custom";
    import ResourceHelper from "@common/globalization/ResourceHelper";


    import {
        BootstrapVue,
        IconsPlugin,
        BButton,
        BDropdown,
        BNavbar,
        BListGroup,
        BNavForm,
        BForm,
        BCard,
        BCardImg,
        BPagination,
    } from "bootstrap-vue";
    import "bootstrap/dist/css/bootstrap.css";
    import "bootstrap-vue/dist/bootstrap-vue.css";
    Vue.component("b-card", BCard);
    Vue.component("b-card-img", BCardImg);
    Vue.component("b-list-group", BListGroup);
    Vue.component("b-navbar", BNavbar);
    Vue.component("b-Form", BForm);
    Vue.component("b-nav-form", BNavForm);
    Vue.component("b-dropdown", BDropdown);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    Vue.component("b-button", BButton);
    Vue.component("b-pagination", BPagination);
    export default {
        name: "Meta Search",
        data() {
            return {
                authorized: false,
                providers: [],
                requestCalls: 0,
                ProductsDataSource: [],
                ProvidersDataSource: [],
                searchKey: "",
                activeProvider: {},
                activeProviderData: {},
                isLoading: false,
                rows: 0,
                currentPage: 1,
                enterMetaSeachKey: "Enter a Meta Search key"
            };
        },
        beforeMount() {
            this.authorized = checkAuth('CompanyModules', 'MetaSearch');
        },
        created() { },
        methods: {

            //Localization
            localize: (string) => {
                let status = ResourceHelper.getString(string);
                return status;
            },
            //Get Providers List
            async getListResult(providerName, searchKey, page = 1) {
                this.activeProviderData = {}
                const providerData = await axios({
                    method: "Get",
                    url: `${config.nbCoreApiUrl}/api/sso/meta-search/${providerName}?query=${searchKey}&page=${page}`,
                    headers: {
                          "portal-id": getCookie("PortalId"),
                        authorization: "Bearer " + getCookie("ApiToken"),
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                    },
                }).finally(() => {
                    this.dissmisLoader();
                });
                return providerData.data;
            },

            //Search By Key
            async search() {
                if (this.searchKey) {
                    this.isLoading = true;
                    //Reset the datasource of providers and products list
                    this.resetDataSource();
                    //Set providers calls
                    this.providers = [
                        this.getListResult("WKO", this.searchKey),
                        this.getListResult("Boorberg", this.searchKey),
                        this.getListResult("HJR", this.searchKey),
                        this.getListResult("Beck", this.searchKey),
                        this.getListResult("SilkCode", this.searchKey),
                    ];
                    let firstIteration = true;
                     this.providers.forEach(async (provider) => {
                        let providerItem = await provider;
                        if (firstIteration) {
                            //Set Current Provider
                            this.currentPage = 1;
                            this.setCurrentProvider(providerItem);
                            firstIteration = false;
                            if (this.activeProvider) {
                                this.isLoading = false;
                            }
                        }
                        this.ProvidersDataSource.push(providerItem);
                        return providerItem;
                    });
                }
            },

            dissmisLoader() {
                this.requestCalls++;
                console.log(this.requestCalls);
                if (this.requestCalls == this.providers.length) {
                    this.isLoading = false;
                    this.requestCalls = 0;
                }
            },
            //Reset the dataSources on search
            resetDataSource() {
                //Reset the datasource of providers and products list
                this.ProvidersDataSource = [];
                this.ProductsDataSource = [];
            },
            setCurrentProvider(provider) {
                //Reset Active Status from Current Active Provider
                this.activeProvider.isActive = false;
                this.currentPage = 1;
                this.rows = "";
                //Set a new provider
                this.activeProviderData = provider.hits;
                this.activeProvider = provider;
                this.activeProvider.isActive = true;
                this.rows = this.activeProvider.totalCount;
            },
            //Handle Pagination
            async handlePageChange(value) {
                this.isLoading = true;
                this.currentPage = value;
                this.activeProviderData = "";
                let data = await this.getListResult(
                    this.activeProvider.provider,
                    this.searchKey,
                    this.currentPage
                );
                if (data) {
                    this.activeProviderData = data.hits;
                    this.isLoading = false;
                }
            },
        },
    };
</script>
<style>
    .metaSearch-content {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        padding: 30px;
    }

        .metaSearch-content .content-row {
            display: flex;
            justify-content: flex-start;
            position: relative;
            min-height: 400px;
        }

            .metaSearch-content .content-row .metaSearch-results {
                flex-grow: 1;
            }

            .metaSearch-content .content-row .content-row-loader {
                position: absolute;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                top: 50%;
                z-index: 9999;
            }

    /* Meta Searchbox & results list */
    .product-card {
        flex-wrap: nowrap;
    }

        .product-card img {
            width: 80px;
            align-self: flex-start;
            padding-right: 10px;
            padding-top: 5px;
        }


        .product-card .card-body {
            padding: 0 10px 10px 10px;
            ;
        }

            .product-card .card-body h6 {
                font-size: 14px;
                font-weight: bold;
                color: #999;
            }

            .product-card .card-body h5 {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 16px;
            }
    /* Meta Search content list */
    .metaSearch-content .content .metaSearch-list {
        width: 200px;
        margin-top: 96px;
        min-width: 200px;
    }

        .metaSearch-content .content .metaSearch-list .metaSearch-list-item {
            color: #fff;
            text-align: center;
            margin-bottom: 5px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            position: relative;
            cursor: pointer;
        }


            .metaSearch-content
            .content
            .metaSearch-list
            .metaSearch-list-item:not(.activeProvider):hover {
                background-color: #414751;
            }



    .list-icon .b-icon {
        padding: 0px !important;
    }

    .logo {
        width: 30% !important;
    }

    .search {
        width: 60% !important;
        display: flex;
        justify-content: center;
    }

    .meta-search-bar {
        width: 100% !important;
        display: flex;
        justify-content: center;
    }

        .meta-search-bar input:focus {
            background-color: #fff !important;
        }


    .meta-form-input {
        width: 400px !important;
        margin-right: -6px !important;
        border-radius: 0;
        height: 35px !important;
    }

    .form-input:focus {
        border: 1px solid rgba(204, 204, 204, 0.966) !important;
        box-shadow: none !important;
        background-color: #fff !important;
    }

    .meta-form-input::placeholder {
        color: #bebebe;
    }

    .form-input:focus, .btn:focus {
        box-shadow: none !important;
    }

    .list-icon {
        width: 20%;
    }

    .products {
        margin-top: 32px;
        margin-bottom: 50px;
        min-width: 600px;
        transition: opacity 0.3s linear 2s;
    }

        .products h5 {
            color: #5b5a5a;
        }

        .products .card {
            border-radius: 0;
            border-bottom: none;
        }

            .products .card:last-of-type {
                border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
            }

    .product-card {
        margin: 10px 20px;
    }

    .icons {
        color: #5b5a5a !important;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        margin: 10px 0px 0px -5px;
    }

        .icons .b-icon {
            padding: 17px !important;
        }

    .products .pagination {
        display: flex;
        padding-left: 0;
        list-style: none;
        border-radius: 0.25rem;
        justify-content: flex-end;
        max-width: 30%;
        margin-top: 1rem;
        margin-left: auto;
    }

    .products .page-link {
        color: #5b5a5a;
    }


        .products .page-link:focus,
        button:focus {
            box-shadow: none !important;
        }

    .meta-form-input.form-input.form-control:focus {
        box-shadow: none !important
    }

    .product-card img {
        min-width: 87px !important;
        max-width: 87px !important;
    }
</style>
